'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _actionTypes = require('./action-types');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    contact: {
        deliveryAddress: {}
    }
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var newState = state;
    switch (action.type) {
        case _actionTypes2.default.CONTACT_CHANGE:
            newState = (0, _extends3.default)({}, state, { contact: (0, _extends3.default)({}, state.contact, action.contact) });
            if (!newState.contact.countryId) newState.contact.countryId = newState.contact.defaultCountryId;
            if (!newState.contact.deliveryAddress.countryId) newState.contact.deliveryAddress.countryId = newState.contact.defaultCountryId;
            break;
        case _actionTypes2.default.DELIVERY_ADDRESS_CHANGE:
            newState = (0, _extends3.default)({}, state, { contact: (0, _extends3.default)({}, state.contact, { deliveryAddressId: action.id }) });
            break;
    }
    return newState;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/customer/reducer.js
// module id = 1156
// module chunks = 0